import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { ValFormReg } from "../../../Validators/ValForms";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import request from "../../../Helpers/API";
import {  MenuItem, TextField } from "@mui/material";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import InfoIcon from "@mui/icons-material/Info";
import { GetDocumentpo } from "../../../Helpers/GetDocumento";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import { ValTextAndNumber } from "../../../Validators/ValTextAndNumber";
const MdlFacturacion = ({ folio, setLoader, loader, updateComentarios }) => {
  const [comentarios, setComentarios] = useState("");
  const [sucursal, setSucursal] = useState([]);
  const [datos_facturacion, setDatosFacturacion] = useState({
    idequip: "",
    idsucursal: "",
    serie_fiscal: "",
    folio_fiscal: "",
    documento: "",
  });
  const [factura, setFactura] = useState({
    documento: "",
    extension: "",
  });
  const [estatus, setEstatus] = useState({});
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACAnalisis_Mhusa_Facturacion/Get?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);
  const onEnviarComentario = (estado) => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    if (
      factura.documento === undefined ||
      factura.documento === null ||
      factura.documento === ""
    ) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        "Favor de anexar la factura ",
        "error"
      );
      return;
    }
    if (
      datos_facturacion.idequip === undefined ||
      datos_facturacion.idequip === null ||
      datos_facturacion.idequip === ""
    ) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        "Favor de anexar el numero de cliente en equip ",
        "error"
      );
      return;
    }
    if (sucursal.length > 1) {
      if (
        datos_facturacion.idsucursal === undefined ||
        datos_facturacion.idsucursal === null ||
        datos_facturacion.idsucursal === ""
      ) {
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          "Favor de anexar la sucursal ",
          "error"
        );
        return;
      }
    }
    if (
      datos_facturacion.serie_fiscal === undefined ||
      datos_facturacion.serie_fiscal === null ||
      datos_facturacion.serie_fiscal === ""
    ) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        "Favor de anexar la serie fiscal ",
        "error"
      );
      return;
    }
    if (
      datos_facturacion.folio_fiscal === undefined ||
      datos_facturacion.folio_fiscal === null ||
      datos_facturacion.folio_fiscal === ""
    ) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        "Favor de anexar el folio fiscal ",
        "error"
      );
      return;
    }
    if (
      datos_facturacion.documento === undefined ||
      datos_facturacion.documento === null ||
      datos_facturacion.documento === ""
    ) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        "Favor de anexar el documento ",
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      factura: factura.documento,
      comentarios,
      estatus: estado,
      idequip: datos_facturacion.idequip,
      idsucursal: datos_facturacion.idsucursal,
      serie_fiscal: datos_facturacion.serie_fiscal,
      folio_fiscal: datos_facturacion.folio_fiscal,
      documento: datos_facturacion.documento,
    };
    request
      .post("ACAnalisis_Mhusa_Facturacion", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
        setComentarios("");
        if (updateComentarios !== undefined && updateComentarios !== null)
          updateComentarios();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };
  const onDatosFacturacion = (prop, value, sbool, smensaje) => {
    setDatosFacturacion({
      ...datos_facturacion,
      [prop]: value,
    });
  };
  const onImprimirArchivo = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD DE CREDITO", error.mensaje, "error");
      });
  };
  const onBlur = () => {
    if (
      datos_facturacion.idequip === undefined ||
      datos_facturacion.idequip === null ||
      datos_facturacion.idequip.length < 6
    ) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        "El numero de cliente en equip debe estar formado por lo menos de 6 numeros",
        "error"
      );
      return;
    }

    setLoader({ ...loader, mostrar: true });

    request
      .get(`ClientesEQUIP/Sucursales?idcliente=${datos_facturacion.idequip}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setSucursal(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  return (
    <div className="analisis-credito-modal-comentarios-jdf">
      <div className="analisis-credito-modal-comentarios-jdf-content">
        <div className="analisis-credito-modal-comentarios-jdf-content-title-center">
          <InfoIcon className="icon-info" /> TIEMPO DE RESPUESTA ESTIMADO:{" "}
          {estatus.tiempoestimado}
        </div>
        <div className="analisis-credito-modal-jdf-content-comentarios">
          {estatus.habilitar === undefined ||
          estatus.habilitar === null ||
          estatus.habilitar === false ? (
            <></>
          ) : (
            <>
              <div className="analisis-jdf-col2">
                <div className="analisis-jdf-col2-documentacion">
                  <TextField
                    fullWidth
                    size="small"
                    label="COMENTARIOS"
                    className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                    multiline
                    rows={4}
                    type="text"
                    onChange={({ target }) => {
                      ValSpecialCharacters(
                        "condiciones",
                        target.value,
                        onChange,
                        true,
                        500
                      );
                    }}
                    value={comentarios}
                  />
                  <div className="analisis-jdf-col2-documentacion-label">
                    CARGAR FACTURA
                  </div>
                  <TextField
                    // label="Cargar Factura"
                    fullWidth
                    type="file"
                    onChange={({ target }) => GetDocumentpo(target, setFactura)}
                    sx={{ mt: 2 }}
                  />
                </div>
                <div className="analisis-jdf-col2-datos-facturacion">
                  <TextField
                    fullWidth
                    size="small"
                    label="NUMERO DE CLIENTE EN EQUIP"
                    className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                    type="text"
                    onChange={({ target }) => {
                      ValOnlyNumber(
                        "idequip",
                        target.value,
                        onDatosFacturacion,
                        true,
                        10
                      );
                    }}
                    value={datos_facturacion.idequip}
                    onBlur={() => onBlur()}
                  />
                  {sucursal === undefined ||
                  sucursal === null ||
                  sucursal.length === 0 ? (
                    <TextField
                      fullWidth
                      size="small"
                      label="SUCURSAL"
                      className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                      type="text"
                      sx={{ mt: 2 }}
                      disabled={true}
                    />
                  ) : sucursal.length === 1 ? (
                    <TextField
                      fullWidth
                      size="small"
                      label="SUCURSAL"
                      className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                      type="text"
                      value={sucursal[0].sucursal}
                      sx={{ mt: 2 }}
                      disabled={true}
                    />
                  ) : (
                    <TextField
                      fullWidth
                      select
                      size="small"
                      label="SUCURSAL"
                      className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                      type="text"
                      value={datos_facturacion.idsucursal}
                      sx={{ mt: 2 }}
                      onChange={({ target }) =>
                        setDatosFacturacion({
                          ...datos_facturacion,
                          idsucursal: target.value,
                        })
                      }
                    >
                      {sucursal.map((suc, index) => (
                        <MenuItem key={index} value={suc.idsucursal}>
                          {suc.sucursal}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}

                  <TextField
                    fullWidth
                    size="small"
                    label="SERIE FISCAL"
                    className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                    type="text"
                    onChange={({ target }) => {
                      ValTextAndNumber(
                        "serie_fiscal",
                        target.value,
                        onDatosFacturacion,
                        true,
                        10
                      );
                    }}
                    value={datos_facturacion.serie_fiscal}
                    sx={{ mt: 2 }}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    label="FOLIO FISCAL"
                    className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                    type="text"
                    onChange={({ target }) => {
                      ValTextAndNumber(
                        "folio_fiscal",
                        target.value,
                        onDatosFacturacion,
                        true,
                        10
                      );
                    }}
                    value={datos_facturacion.folio_fiscal}
                    sx={{ mt: 2 }}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    label="DOCUMENTO EQUIP"
                    className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                    type="text"
                    onChange={({ target }) => {
                      ValOnlyNumber(
                        "documento",
                        target.value,
                        onDatosFacturacion,
                        true,
                        10
                      );
                    }}
                    value={datos_facturacion.documento}
                    sx={{ mt: 2 }}
                  />
                </div>
              </div>

              <div className="analisis-credito-modal-jdf-content-buttons">
                <div></div>
                <div
                  className="analisis-credito-modal-pedido-content-acept-button"
                  onClick={() => {
                    onEnviarComentario("A");
                  }}
                >
                  <CheckCircleIcon />
                  <div>ACEPTAR</div>
                </div>
              </div>
            </>
          )}
        </div>
        {estatus.habilitar === undefined ||
          estatus.habilitar === null ||
          (estatus.habilitar === false && (
            <>
              <div
                className={`analisis-credito-modal-pedido-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
              >
                <label>Comentarios</label>
                <div className="analisis-credito-modal-pedido-content-comentarios-svg">
                  <OnGetIcon icon={estatus.icono} />
                </div>
                <div className="analisis-credito-modal-pedido-content-comentarios-div">
                  {estatus.comentarios}
                </div>
              </div>
              {estatus.factura !== undefined &&
                estatus.factura !== null &&
                estatus.factura === true && (
                  <div
                    className="analisis-credito-modal-pedido-content-pdf"
                    onClick={() => onImprimirArchivo(28)}
                  >
                    <CloudDownloadIcon />
                    <div>DESCARGAR FACTURA</div>
                  </div>
                )}
            </>
          ))}
      </div>
      <div className="analisis-credito-modal-pedido-footer"></div>
    </div>
  );
};

export default MdlFacturacion;
